// extracted by mini-css-extract-plugin
export var buttonHoverColor = "index-module--buttonHoverColor--80168";
export var coming = "index-module--coming--88dfd";
export var content = "index-module--content--bbd30";
export var icon = "index-module--icon--c7332";
export var inner = "index-module--inner--2e1ce";
export var item = "index-module--item--ad18f";
export var itemButton = "index-module--itemButton--39957";
export var label = "index-module--label--20f32";